<script>
    import { auth, db, googleProvider } from '../../firebase/firebase.config';

	// Stores
    import {UserStore} from '../../store';

    let inputFullname;
    let inputEmail;
    let inputPassword;

    // Handle Sign-up User through email & password.
    const handleSignupUser = (e) => {
        auth.createUserWithEmailAndPassword(inputEmail, inputPassword)
        .then(cred => {

            let user = auth.currentUser;

            user.updateProfile({
                displayName: inputFullname
            }).then(function() {
                console.log('displayName updated');
                auth.onAuthStateChanged((user) => {
                    if(user) {
                        let displayName = user.displayName;
                        let uid = user.uid;

                        
                        UserStore.update(currentUser => {
                            return {
                                fullName: displayName,
                                uid: uid,
                                authStatus: true
                            }
                        });
                    } else {
                        UserStore.update(currentUser => {
                            return {
                                authStatus: false
                            }
                        });
                    }
                });
            }).catch(function(err) {
                console.log('displayName update failed', err);
            });
        }).catch(err => {
            console.log('create user failed', err);
        });
    };

    // Handle Sign-up User through Google.
    const handleGoogleSignup = (e) => {
        auth.signInWithPopup(googleProvider)
        .then(result => {
            let token = result.credential.accessToken;
            let user = result.user;
        }).catch(err => {
            console.log('google signup err', err)
        });
    };
</script>

<form class="form-signup" on:submit|preventDefault={handleSignupUser}>
    <h1 class="h3 mb-3 font-weight-normal">Please sign up</h1>

    <label for="inputFullName" class="sr-only">Full Name</label>
    <input type="text" id="inputFullName" class="form-control" placeholder="Full Name" required="" bind:value={inputFullname}>

    <label for="inputEmail" class="sr-only">Email address</label>
    <input type="email" id="inputEmail" class="form-control" placeholder="Email address" required="" bind:value={inputEmail}>

    <label for="inputPassword" class="sr-only">Password</label>
    <input type="password" id="inputPassword" class="form-control" placeholder="Password" required="" bind:value={inputPassword}>

    <button class="btn btn-lg btn-primary btn-block" type="submit">Sign up</button>
    
    <!-- Firebase Authenication Btns -->
    <button class="btn btn-link btn-lg w-100 text-center text-white mt-3" on:click={handleGoogleSignup}>Sign Up with Google</button>
</form>